import React, { useEffect, useState } from "react";
import Select from "react-select";
import StorageUtils from "@/utility/StorageUtils";
import { useTranslation } from "react-i18next";

const lang = [
  {
    code: "en",
    label: "English",
  },
  {
    code: "es",
    label: "Spanish",
  },
];

const Language = () => {
  const options = lang.map(({ code: value, label }) => {
    return { label, value };
  });

  const { t: translate, i18n } = useTranslation("pricing");

  const [selectedLanguage, setSelectedLanguage] = useState(() =>
    options.find((v) => {
      return v.value === (StorageUtils.getItem("defaultLanguage") || "en");
    })
  );

  useEffect(() => {
    StorageUtils.setItem("defaultLanguage", selectedLanguage.value);
    i18n.changeLanguage(selectedLanguage.value);
  }, [selectedLanguage]);

  return (
    <React.Fragment>
      <a className="uk-text-capitalize uk-text-bold" type="button">
        {selectedLanguage.label}{" "}
        <span uk-icon="icon: chevron-down; ratio: 1"></span>
      </a>

      <div uk-dropdown="mode: hover;" className="">
        <Select
          name="id"
          options={options}
          onChange={(evt) => {
            setSelectedLanguage(evt);
          }}
          defaultValue={selectedLanguage}
        />
      </div>
    </React.Fragment>
  );
};

export default Language;
